"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRemoteImageGroupOverlapSpacing = void 0;
var _useAvatarSize = require("../media/useAvatarSize");
const smallerOverlapSizes = ['m', 'l', 'xl'];
const getRemoteImageGroupOverlapSpacing = size => {
  if (typeof size === 'number' && size <= _useAvatarSize.normalScaleMap.xl || typeof size === 'string' && smallerOverlapSizes.includes(size)) {
    return 1;
  }
  return 2;
};
exports.getRemoteImageGroupOverlapSpacing = getRemoteImageGroupOverlapSpacing;